import { CheckoutRequestModel } from '@/models/CheckoutRequestModel';
import { CheckoutRequestRawModel } from '@/api/api-raw-models/checkout-request-raw-model';

/* eslint-disable @typescript-eslint/camelcase */
export function mapCheckoutRequest(e: CheckoutRequestModel): CheckoutRequestRawModel {
  const request: CheckoutRequestRawModel = {
    order_name: e.orderName,
    pickup_date_time: e.pickupDateTime,
    platform: e.platform,
    square_nonce: e.squareNonce,
    to_go: e.toGo,
  };

  if (e.email) {
    request.email = e.email;
  }
  return request;
}
